import { createMigrate, createTransform } from "redux-persist";
// import storage from "redux-persist/lib/storage";
import storage from "localforage";
import { defaultState as userDefault, UserState } from "./User";
import { createHashHistory, History } from "history";
import { routerMiddleware, RouterState } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import ReactGA from "react-ga4";
import { logout, SSOCallback } from "@10x/sso";
import Actions from "@my-dld/actions";
import { MigrationManifest } from "redux-persist/es/types";
import { UserDataState } from "./UserData";
import { TempDataState } from "./TempData";
import { hasAnalytics } from "@my-dld/utils/Analytics";
import { EjariDataState } from "@eres/ejari-core/reducers/EjariData";
import { EjariContractDataState } from "@eres/ejari-core/reducers/EjariContractData";
import { TenantContractDataState } from "@eres/ejari-core/reducers/TenantContractData";
import { TenantDataState } from "@eres/ejari-core/reducers/TenantData";
import { LeasedDataState } from "@eres/ejari-core/reducers/LeasedData";
import { UserMiddlewareConfig, UserVersionMiddleWare } from "./UserMiddleware";
import { PvtSellResponse } from "../apis/privatesell/enitites";
import { getAppServices } from "@10x/coreapp";
import { ManagementContractDataState } from "@eres/ejari-core/reducers/ManagementContractData";

export interface IStore {
	User: UserState,
	router: RouterState,
	UserData: UserDataState,
	TempData: TempDataState,
	EjariData: EjariDataState,
	EjariContractData: EjariContractDataState,
	ManagementContractData: ManagementContractDataState,
	TenantData: TenantDataState,
	TenantContractData: TenantContractDataState,
	LeasedData: LeasedDataState,
	PSBookingRequest: PvtSellResponse,
}

const history: History = createHashHistory();
// @ts-ignore
history.listen( ( location, action ) => {
	hasAnalytics() && ReactGA.send(location.pathname);
	window.scrollTo( { top: 0 } );
} );
export { history };
const migrations: MigrationManifest = {
	"0": ( state ) => {
		return {
			...state,
			User: userDefault,
		} as any;
	},
	"1": ( state: any ) => {
		return {
			...state,
			User: {
				...userDefault,
				...state.User,
			},
		} as any;
	},
	"2": ( state: any ) => {
		return {
			...state,
			User: {
				...userDefault,
				...state.User,
			},
		} as any;
	},
	"3": ( state: any ) => {
		return {
			...state,
			User: {
				...userDefault,
				...state.User,
				RequiredUserVersion: 2,
			},
		} as any;
	},
};

let blacklist = true ? [ "router", "TempData" ] : [ "UserData", "router", "TempData" ];

//ejari ctx custom black lister
const EjariCtxTransformer = createTransform(
	null,
	( state: EjariDataState, key ) => {
		const newState = { ...state };
		newState.lastPropertyTime = 0;
		return newState;
	},
	{ whitelist: [ "EjariData" ] }
);
const persistConfig = {
	key: "root",
	version: 3,
	storage: storage,
	migrate: createMigrate( migrations, { debug: false } ),
	transforms: [ EjariCtxTransformer ],
	blacklist: blacklist,
};
const middleWares: any = [ routerMiddleware( history ), UserVersionMiddleWare ];
const composeEnhancers = composeWithDevTools( {
	// Specify here name, actionsBlacklist, actionsCreators and other options
} );

export { persistConfig, middleWares, composeEnhancers };
SSOCallback.updateUser = ( user: any ) => {
	const store = getAppServices().storeService.getStore();
	store.dispatch( {
		type: Actions.USER_LOGGED_IN,
		payload: user,
		oldUser: store.getState().User.user,
	} );
};
SSOCallback.getStoredUser = () => {
	const store = getAppServices().storeService.getStore();
	return store.getState().User.user;
};
UserMiddlewareConfig.logout = () => {
	const store = getAppServices().storeService.getStore();
	store.dispatch( {
		type: Actions.USER_LOGGED_OUT,
	} );
	logout().then().catch();
};
